// frontend/src/hooks/useAuth.js
import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAuth = () => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [userPayload, setUserPayload] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const currentToken = localStorage.getItem('token');
    setToken(currentToken);
    if (currentToken) {
      try {
        const payload = JSON.parse(atob(currentToken.split('.')[1]));
        setUserPayload(payload);
      } catch (error) {
        console.error('useAuth: Fehler beim Parsen des Tokens:', error);
        // Bei ungültigem Token ausloggen
        logout();
      }
    } else {
      setUserPayload(null);
    }
  }, [token]); // Abhängigkeit von token, um auf Änderungen zu reagieren

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    setToken(null);
    setUserPayload(null);
    navigate('/');
  }, [navigate]);

  // Funktion zum Behandeln von API-Fehlern (insbesondere 401/403)
  const handleApiError = useCallback((error) => {
      if (error?.status === 401 || error?.status === 403) {
          console.error("useAuth: Authentifizierungsfehler erkannt, Logout wird eingeleitet.", error);
          logout();
      } else {
          // Andere Fehler könnten hier geloggt oder anders behandelt werden
          console.error("useAuth: API Fehler:", error);
      }
  }, [logout]);


  return { token, userPayload, logout, handleApiError };
};
